import { z } from 'zod';
import { supplyNameSchema, supplyNumSchema } from './fields';

export const putSupplySchema = (t) =>
  z.object({
    number: supplyNumSchema(t),
    name: supplyNameSchema(t),
  });
